let isBootstrapDataFetched = false;
let isInboxContextDataFetched = false;
let lastOktaUserId: string | null = null;

export const getBootstrapDataFetched = () => isBootstrapDataFetched;
export const setBootstrapDataFetched = (value: boolean) => {
  isBootstrapDataFetched = value;
};

export const getInboxContextDataFetched = () => isInboxContextDataFetched;
export const setInboxContextDataFetched = (value: boolean) => {
  isInboxContextDataFetched = value;
};

export const getLastOktaUserId = () => lastOktaUserId;
export const setLastOktaUserId = (value: string | null) => {
  lastOktaUserId = value;
};

export const resetAuthLoaderFlags = () => {
  isBootstrapDataFetched = false;
  isInboxContextDataFetched = false;
  lastOktaUserId = null;
};
